/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_New_MediaInputs */

const en_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add New Media`)
};

const es_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir nuevos medios`)
};

const fr_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter de nouveaux médias`)
};

const de_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Medien hinzufügen`)
};

const ja_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいメディアを追加`)
};

const zh_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加新媒体文件`)
};

const ar_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافة وسائط جديدة`)
};

const id_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah Media Baru`)
};

const it_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi Nuovi Media`)
};

const ru_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить новые медиа`)
};

const pt_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar Nova Mídia`)
};

const ko_add_new_media = /** @type {(inputs: Add_New_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 미디어 추가`)
};

/**
* | output |
* | --- |
* | "Add New Media" |
*
* @param {Add_New_MediaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_new_media = /** @type {((inputs?: Add_New_MediaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_New_MediaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_new_media(inputs)
	if (locale === "es") return es_add_new_media(inputs)
	if (locale === "fr") return fr_add_new_media(inputs)
	if (locale === "de") return de_add_new_media(inputs)
	if (locale === "ja") return ja_add_new_media(inputs)
	if (locale === "zh") return zh_add_new_media(inputs)
	if (locale === "ar") return ar_add_new_media(inputs)
	if (locale === "id") return id_add_new_media(inputs)
	if (locale === "it") return it_add_new_media(inputs)
	if (locale === "ru") return ru_add_new_media(inputs)
	if (locale === "pt") return pt_add_new_media(inputs)
	return ko_add_new_media(inputs)
});